import { Component, OnInit, ElementRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ExtractionMutated, FileTypes, SelectedExtractionDto } from '@emi/shared/models';
import { FocusableOption } from '@angular/cdk/a11y';
import { DataExtractionState, downloadExtraction, getFilterNames, getFilterSelections, isLoadingSelections, updateReloadedExtraction } from '@emi/shared/state/filters';
import { Store } from '@ngrx/store';
import * as moment from 'moment';

import { MatCheckboxChange } from '@angular/material/checkbox';
import { getSkuCountSuccess } from '@emi/shared/state/sku-search';

@Component({
    selector: 'via-extraction-row',
    templateUrl: './extraction-row.component.html',
    styleUrls: ['./extraction-row.component.scss'],
})
export class ExtractionRowComponent implements OnInit, FocusableOption {
    @ViewChild('extractionRow')
    public extractionRow: ElementRef;

    @Input()
    public extraction: ExtractionMutated;

    @Output()
    public selectExtractionRowEvent = new EventEmitter<SelectedExtractionDto>();

    public isExpanded: boolean;
    public daysExtractionValid = 7;

    constructor(private readonly store: Store<DataExtractionState>) {}

    public ngOnInit(): void {
        this.isExpanded = this.extraction.isLoaded;
    }

    public isButtonDisabled(): boolean {
        return (
            this.getExpirationText() == 'Expired' ||
            this.extraction.status == 'Pending' ||
            this.extraction.status == 'Failed' ||
            this.extraction.status == 'TimedOut' ||
            this.extraction.isDownloading
        );
    }

    public navigateToFilterData(): void {
        this.store.dispatch(getSkuCountSuccess({ skuCount: 0 }));
        this.store.dispatch(isLoadingSelections({ isLoading: true }));
        this.store.dispatch(updateReloadedExtraction({ reloadedExtraction: this.extraction }));
        this.store.dispatch(getFilterSelections({ extraction: this.extraction }));
    }

    public getStatus(): string {
        if (this.extraction.status === 'Done') {
            return this.getExpirationText();
        }

        if (this.extraction.status == 'TimedOut') {
            return 'Timed Out';
        }

        return this.extraction.status;
    }

    public getExpirationText(): string {
        const difference: number =
            moment.utc(this.extraction.dateCreated).startOf('day').diff(moment.utc().startOf('day'), 'days') + this.daysExtractionValid;

        if (difference > 0) {
            return `Expires in ${difference} ${difference > 1 ? 'days' : 'day'}`;
        }

        return 'Expired';
    }

    public toggleExtractionRow(): void {
        this.isExpanded = !this.isExpanded;

        if (this.isExpanded && Object.values(this.extraction.filterNames).every((filterType) => filterType.length === 0)) {
            this.store.dispatch(
                getFilterNames({
                    extraction: this.extraction,
                })
            );
        }
    }

    public focus(): void {
        this.extractionRow.nativeElement.focus();
    }

    onSelect(extractionChecked: MatCheckboxChange, selectedId: number) {
        const selectedExtraction = new SelectedExtractionDto(selectedId, extractionChecked.checked);
        this.selectExtractionRowEvent.emit(selectedExtraction);
    }

    public downloadClick(extractionId: number, extractionName: string, fileType: FileTypes, includeAttributesFile: boolean): void {
        this.store.dispatch(downloadExtraction({ extractionId, extractionName, fileType, includeAttributesFile }));
    }

    public isTotalSKUSizeOrRangeFilterApplied(): boolean {
        return (this.extraction.startDate && this.extraction.endDate) ||
            this.extraction.skuFilters.firstSeenPriceRange ||
            this.extraction.skuFilters.lastSeenPriceRange ||
            this.extraction.skuFilters.volumeRange ||
            this.extraction.skuFilters.weightRange ||
            this.extraction.skuFilters.countRange
            ? true
            : false;
    }
}
